export default __webpack_public_path__ + "static/media/details2.7547d864.jpg";